import * as React from 'react'
import {Box} from "@mui/material";
import { CircularPercentageSeeker } from "@ui-seeker/core";
import { formatNumber } from "@ui-seeker/utils";

import { NotAllowedBlock } from "@components";


export default function scoreColumn() {
    return {
        name: 'score', label: 'Score',
        options: {
            filter: false,
            customBodyRowRenderLite: (value, row) => {
                return <Box sx={{ display: "flex", justifyContent: "center" }}>
                    {!row.hasData && <NotAllowedBlock />}
                    {!!row.hasData && <CircularPercentageSeeker
                        value={value}
                        formatter={val => formatNumber(val, { decimals: 1 })}
                        pattern={[
                            { value: 89, color: "success.light" },
                            { value: 79, color: "success.lighter" },
                            { value: 69, color: "warning.lighter" },
                            { value: 49, color: "warning.light" },
                            { value: 29, color: "error.lighter" },
                            { value: "else", color: "error.light" }
                        ]}
                    />}
                </Box>
            }
        }
    }
}